import { Injectable } from '@angular/core';
import { SettingsProviderService } from './providers/settings.provider.service';
import { IMultiwayRestriction } from '../models/settings/multiwayRestriction.interface';
import { map } from 'rxjs/operators';
import { ModelMapperService } from './util/model.mapper.service';
import { ITicketOutcomeIdentifyer } from '../models/ticket/ticketOutcomeIdentifyer.interface';

@Injectable()
export class OutcomeExclusionsService {


    private possibilityMatrix: { [betTypeOutcomeId: number]: IMultiwayRestriction };
    isRestricted: boolean;


  constructor(
    private settingsProvider: SettingsProviderService,
    private modelMapperService: ModelMapperService) {
    this.possibilityMatrix = JSON.parse(localStorage.getItem('restrictions'));
    if (!this.possibilityMatrix) {
      settingsProvider.getMultiwayRestrictions().pipe(
        map((mwrsTO) => {
          const possibilityMatrix: { [betTypeOutcomeId: number]: IMultiwayRestriction } = {};
          Object.entries(mwrsTO).forEach(([btoId, mw]) => {
            possibilityMatrix[btoId] = modelMapperService.mapMultiwayRestriction(mw);
          });
          return possibilityMatrix;
        })
      ).subscribe((res: { [betTypeOutcomeId: number]: IMultiwayRestriction }) => {
        localStorage.setItem('restrictions', JSON.stringify(res));
        this.possibilityMatrix = res;
      });
    }
  }


    checkIfCombinationIsPossible(outcomes: ITicketOutcomeIdentifyer[]): boolean {
        for (let i = 0; i < outcomes.length - 1; i++)
        {
           // console.log('i=' + i);
            for (let j = 1; j < outcomes.length; j++)
            {
               // console.log('j=' + j);
                if (!this.possibilityMatrix[outcomes[i].outcomeTypeId]) {
                   break;
                }
                const temp = this.possibilityMatrix[outcomes[i].outcomeTypeId].restrictions;
                if (temp.some(x => x.betTypeOutcomeId === outcomes[j].outcomeTypeId) === true) {
                    return false;
                }
            }
        }

        return true;
    }
}
